import { useCallback, useState } from "react";
import useDebounce from "./useDebounce";
import { usePaginationState } from "./usePaginationState";

type UseSearchPaginationOptions = {
  defaultPageSize?: number;
  debounceMs?: number;
};

/** Поиск с задержкой плюс пагинация одной таблицы. */
export function useSearchPagination({
  defaultPageSize = 10,
  debounceMs = 400,
}: UseSearchPaginationOptions = {}) {
  const { pagination, handlePageChange, goToFirstPage } =
    usePaginationState(defaultPageSize);

  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, debounceMs);

  /** Новый запрос показывает другой набор записей — начинаем с первой страницы. */
  const handleChangeSearch = useCallback(
    (value: string) => {
      goToFirstPage();
      setSearch(value);
    },
    [goToFirstPage],
  );

  return {
    pagination,
    search,
    debouncedSearch,
    handleChangeSearch,
    handlePageChange,
  };
}
